// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//  staging environment

//  export const environment = {
//   production: false,
//   API_BASE_PATH: "https://api.pcrown.net/", //dev url
//   Checkin_BASE_PATH: "https://pcrown.net",
//   API_BASE_PATH_Hq: "https://api.pcrown.net/hq/", //dev url
//   HA_API_KEY: "EV-OCT-EVENT-BIZBRO-2020LLY",
//   HA_API_BASE_PATH: "http://3.23.121.56/Healthsist/",
//   API_KEY: "EV-OCT-EVENT-BIZBRO-2020LLY",
//   socketUrl: "https://socket.pcrown.net/",
//   SelfOnboarding_Key: "EV-OCT-EVENT-BIZBRO-2020LLY",
//   siteKey: "6LeRwk0gAAAAAP3rBC5O1KfqMdepTBlBh3rK8Ai7",
//   adminUrl: "https://admin.pcrown.net",
//   blogBaseUrl: "https://www.pcrown.net",
//   googleMapKey: "AIzaSyCpYF-ryM0RTrFdwU-NCdfN5lQgG1vaV_w",
//   customDropdownApiUrl: "https://socket.pcrown.net/searchGoogleLocation",
//   ImageBasePath: "https://admin.pcrown.net",
//   transactionKey: "3hqNH3m7WM698u5D",
//   copayIframeUrl: `https://pcrown.net/IframeUrl`,
//   paymentUrl: `https://apitest.authorize.net/xml/v1/request.api`,
//   merchantName: `Instant UrgentCare`,
//   formActionUrl: `https://test.authorize.net/payment/payment`,
//   LoginId:'6u8CMf8p',
//   resetPasswordLink: "https://pcrown.net/d/portal/reset-password",
//   sickVisitAppointmenttypeid: "485225",
//   teleMadAppointmenttypeid: 101,
//   blogImageBasePath:'https://api.pcrown.net/hq',
//   pdfBasePath: `https://api.pcrown.net/d/`,
//    cookieDomain:'.pcrown.net',
//   // cookieDomain: ".localhost",
//   keyrefreshlimit: 2,
//    version: "1.0.0",
//   version_message: "An update is available. Please refresh the page."
// };


export const environment = {
  production: true,
  API_BASE_PATH: "https://api.practicecrown.com/",
  Checkin_BASE_PATH: "https://practicecrown.com",
  API_BASE_PATH_Hq: "https://api.practicecrown.com/hq/", // please don`t change the hq api base path
  API_KEY: "EV-OCT-EVENT-BIZBRO-2020LLY",
  SelfOnboarding_Key: 'EV-OCT-EVENT-BIZBRO-2020LLY',
  socketUrl: 'https://socket.practicecrown.com/',
  TWILIO_ACCOUNT_SID: "AC01a570bd3744e537297c979110e8646f",
  TWILIO_API_KEY_SECRET: "UzmCwayaWMstvC74zQVqwRnO1JbtJLHi",
  TWILIO_API_KEY_SID: "SKe9570f0d60cb8d3bd60378fbba15e416",
  HA_API_KEY: 'EV-OCT-EVENT-BIZBRO-2020LLY',
  HA_API_BASE_PATH: 'http://3.23.121.56/Healthsist/',
  medhealth: 'https://api.practicecrown.com/Medhealth/',
  medhealthSocketUrl: 'https://socket.pcrown.dev',
  siteKey: '6LeRwk0gAAAAAP3rBC5O1KfqMdepTBlBh3rK8Ai7',
  adminUrl: 'https://admin.practicecrown.com',
  blogBaseUrl: 'https://practicecrown.com',
  googleMapKey: 'AIzaSyCpYF-ryM0RTrFdwU-NCdfN5lQgG1vaV_w',
  aucUrgentCare: 'https://www.accessurgentcare.io/services#urgent-care',
  customDropdownApiUrl: 'https://socket.practicecrown.com/searchGoogleLocation',
  ImageBasePath: 'https://admin.practicecrown.com',
  transactionKey: "3hqNH3m7WM698u5D",
  copayIframeUrl: `https://practicecrown.com/IframeUrl`,
  paymentUrl: `https://apitest.authorize.net/xml/v1/request.api`,
  merchantName: `Instant UrgentCare`,
  formActionUrl: `https://test.authorize.net/payment/payment`,
  resetPasswordLink: 'https://practicecrown.com/d/portal/reset-password',
  pdfBasePath: `https://admin.practicecrown.com/`,
  blogImageBasePath: 'https://api.practicecrown.com/hq',
  LoginId: '6u8CMf8p',
  cookieDomain: '.practicecrown.com',
  // cookieDomain: ".localhost",
  keyrefreshlimit: 2,
  version: '8.0.0',

  version_message: 'An update is available. Please refresh the page.',
  checkoutSessionTime: 6,
  squareApplicationId: "",
  squareLocationId: ""
};




// export const environment = {
//   production: true,
//   API_BASE_PATH:"https://api.practicecrown.com/",
//   Checkin_BASE_PATH:"https://practicecrown.com",
//   API_BASE_PATH_Hq: "https://api.practicecrown.com/hq/", // please don`t change the hq api base path
//   API_KEY:"EV-OCT-EVENT-BIZBRO-2020LLY",
//   SelfOnboarding_Key:'EV-OCT-EVENT-BIZBRO-2020LLY',
//   socketUrl:'https://socket.practicecrown.com/',
//   TWILIO_ACCOUNT_SID:"AC01a570bd3744e537297c979110e8646f",
//   TWILIO_API_KEY_SECRET :"UzmCwayaWMstvC74zQVqwRnO1JbtJLHi",
//   TWILIO_API_KEY_SID :"SKe9570f0d60cb8d3bd60378fbba15e416",
//   HA_API_KEY: 'EV-OCT-EVENT-BIZBRO-2020LLY',
//   HA_API_BASE_PATH: 'http://3.23.121.56/Healthsist/',
//   siteKey : '6LeRwk0gAAAAAP3rBC5O1KfqMdepTBlBh3rK8Ai7',
//   adminUrl:'https://admin.practicecrown.com',
//   blogBaseUrl:'https://practicecrown.com',
//   googleMapKey:'AIzaSyCpYF-ryM0RTrFdwU-NCdfN5lQgG1vaV_w',
//   customDropdownApiUrl: 'https://socket.practicecrown.com/searchGoogleLocation',
//   ImageBasePath:'https://admin.practicecrown.com',
//   transactionKey: "3hqNH3m7WM698u5D",
//   copayIframeUrl: `https://practicecrown.com/IframeUrl`,
//   paymentUrl: `https://apitest.authorize.net/xml/v1/request.api`,
//   merchantName: `Instant UrgentCare`,
//   formActionUrl: `https://test.authorize.net/payment/payment`,
//   resetPasswordLink:'https://practicecrown.com/d/portal/reset-password',
//   pdfBasePath:`https://admin.practicecrown.com/`,
//   blogImageBasePath:'https://api.practicecrown.com/hq',
//   LoginId:'6u8CMf8p',
// //  cookieDomain:'.localhost',
// cookieDomain:'.practicecrown.com',
// keyrefreshlimit: 3
// };
